import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, inject, LOCALE_ID, NgModule, provideExperimentalZonelessChangeDetection,} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {LayoutComponent} from './layout.component';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NgHttpLoaderModule} from 'ng-http-loader';
import {registerLocaleData} from '@angular/common';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import {MetecNavigationComponent} from './core/navigation/metec-navigation.component';
import {DashboardComponent} from './core/dashboard/dashboard.component';
import {InlineSVGConfig, InlineSVGModule} from "ng-inline-svg-2";
import localeEt from '@angular/common/locales/et';
import {DragDropModule} from '@angular/cdk/drag-drop'
import {AppConfig, appInitializerFn, BaseStateService, baseSvgConfigFn, ChangeDetectionLoggingComponent, CommonSharedModule, getBaseUrl, HelpModule, NgbDateMomentParserFormatter, NotificationAreaComponent, TranslocoHttpLoader} from 'common-shared';
import {ActionBarModule, StateService, UserHasPrivilegePipe, WebSharedModule} from 'web-shared';
import {NgbCollapseModule, NgbDateAdapter, NgbDateNativeAdapter, NgbDateParserFormatter, NgbDropdownModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastContainerDirective, ToastrModule} from "ngx-toastr";
import {NgSelectModule} from "@ng-select/ng-select";
import {provideTransloco, TranslocoModule} from "@jsverse/transloco";
import {environment} from "../environments/environment";
import customizeLocale from 'angular-custom-locale';
import {NgStringPipesModule} from "ngx-pipes";
import {ImeComponentsModule} from "ime-shared";

customizeLocale(localeEt, {
  numbers: {
    //minusSign: '-',
    group: '',    // number group separator, was ' '
  }
});

registerLocaleData(localeEt);

let appConfig = new AppConfig({
  name: 'metec-ime',
  apiResponseCollapseEnabled: true,
  apiResponseLineCollapseLimit: 1
});

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    MetecNavigationComponent,
    DashboardComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonSharedModule.forRoot(appConfig),
    WebSharedModule.forRoot(appConfig),
    BrowserModule,
    NoopAnimationsModule,
    AppRoutingModule,
    ActionBarModule,
    NgbTooltipModule,
    NgSelectModule,
    InlineSVGModule.forRoot(),
    NgHttpLoaderModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
      enableHtml: true,
      closeButton: true,
      countDuplicates: true,
      disableTimeOut: true
    }),
    ToastContainerDirective,
    DragDropModule,
    NgbDropdownModule,
    NgbCollapseModule,
    TranslocoModule,
    NgStringPipesModule,
    ImeComponentsModule,
    NotificationAreaComponent,
    HelpModule,
    UserHasPrivilegePipe,
    ChangeDetectionLoggingComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        return appInitializerFn(environment, inject(HttpClient));
      },
      multi: true
    },
    {
      provide: InlineSVGConfig, useFactory: () => {
        return baseSvgConfigFn(environment);
      }
    },
    {provide: LOCALE_ID, useValue: 'et'},
    {provide: 'BASE_URL', useFactory: getBaseUrl},
    {provide: NgbDateAdapter, useClass: NgbDateNativeAdapter},
    {provide: BaseStateService, useExisting: StateService},
    {
      provide: NgbDateParserFormatter,
      useFactory: () => {
        return NgbDateMomentParserFormatter.Create("dd.MM.yyyy");
      }
    },
    provideTransloco({
      config: {
        availableLangs: [
          'en',
          'et'
        ],
        defaultLang: 'en',
        fallbackLang: 'en',
        missingHandler: {logMissingKey: false},
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideExperimentalZonelessChangeDetection()
  ]
})
export class MetecImeModule {

}

